import React, { useState } from "react";
import { Button } from "@onegovbugs/onegov-react-components";
import styles from "./FocusOfWork.module.scss";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Create from "@material-ui/icons/Create";

export const FocusOfWorkList = ({
  props,
  focusOfWorkList,
  deleteActionHandler,
}) => {
  return (
    <>
      {focusOfWorkList && focusOfWorkList.map((el, i) => (
        <div key={"loc-" + i} className={`${styles.editSection}`}>
          <>
            <div className={"row"}>
              <div className={"col-3"}>
                <label>Species Type</label>
              </div>
              <div className={"col-7 " + styles.divContent}>
                {el.speciesType}
              </div>
              <div className={"col-2 " + styles.editButtonSection}>
                <Create
                  onClick={() => {
                    props.history.push(`./focusOfWork/detail/${i}`);
                  }}
                />
                <DeleteOutline
                  onClick={() => {
                    deleteActionHandler(i);
                  }}
                />
              </div>
            </div>
            {el.commonName.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Common Name</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.commonName.label}
                </div>
              </div>
            )}
            {el.sampleUnit.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Sample Unit</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.sampleUnit.value}
                </div>
              </div>
            )}
            {el.targetPart.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Target Part</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.targetPart.value}
                </div>
              </div>
            )}
            {el.speciesSearch.value && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>Family / Genus / Species / Subspecies</label>
                </div>
                <div className={"col-7 " + styles.divContent}>
                  {el.speciesSearch.label}
                </div>
              </div>
            )}
            {el.targetPartNumber && (
              <div className={"row"}>
                <div className={"col-3"}>
                  <label>No Of Target Parts</label>
                </div>
                <div className={"col-7 " + styles.divContent}>{el.targetPartNumber}</div>
              </div>
            )}
          </>
        </div>
      ))}
    </>
  );
};

export default FocusOfWorkList;
